import { getTimezones } from '@/utils/helpers';
import { NameByValue } from '@/types';
import { OrganType } from '@/api/apis/case';
import { REGIONS } from './location.constants';
import { PerfusionSetOrganType, DriverAffiliationType, OcsConsoleStatus } from '@/api/apis/resources';

export const TIMEZONES_SELECT_LIST = getTimezones();
export const TIMEZONES_WITH_UTC_SELECT_LIST = [{ value: 'UTC', name: 'UTC' }, ...getTimezones()];

export const REGIONS_SELECT_LIST = REGIONS.map<NameByValue>((r) => ({ value: r, name: r }));

export const ORGAN_SELECT_LIST = [
  {
    value: OrganType.Liver,
    name: 'Liver',
  },
  {
    value: OrganType.Heart,
    name: 'Heart',
  },
  {
    value: OrganType.Lungs,
    name: 'Lungs',
  },
  {
    value: OrganType.Kidney,
    name: 'Kidney',
  },
];

export const OCS_CONSOLES_STATUS_LIST = [
  {
    value: OcsConsoleStatus.Available,
    name: 'Available',
  },
  {
    value: OcsConsoleStatus.OnCase,
    name: 'Assigned',
  },
  {
    value: OcsConsoleStatus.Reserved,
    name: 'Reserved',
  },
];

export const PERFUSION_SETS_ORGAN_LIST = [
  {
    value: PerfusionSetOrganType.LiverPerfusionSet,
    name: 'Liver',
  },
  {
    value: PerfusionSetOrganType.HeartPerfusionSet,
    name: 'Heart',
  },
  {
    value: PerfusionSetOrganType.LungPerfusionSet,
    name: 'Lungs',
  },
  {
    value: PerfusionSetOrganType.KidneyPerfusionSet,
    name: 'Kidney',
  },
];

export const BANNED_DRIVERS_AFFILATION_LIST = [
  {
    value: DriverAffiliationType.TMDX,
    name: 'TMDX Affiliate',
  },
  {
    value: DriverAffiliationType.TXCenterProvider,
    name: 'TX Center Provider',
  },
];

export const MAX_LENGTH_2000 = 2000;
export const MAX_LENGTH_500 = 500;
export const MAX_LENGTH_LONG_TEXT = 6000;
